import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { ConfirmButtonGroup } from '../confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal/index.ts';
import { UpsellTable } from './UpsellTable.tsx';

type Props = {
  onClose: () => void;
};

export function UpsellModal({ onClose }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>Free plan limit reached</ModalHeader>
      <ModalBody>
        <h2 className="h4">Unlock all features for only $1/mo per host</h2>

        <p className="p">
          You’ve hit the limit of what you can do with the free plan. Upgrade to Pro or{' '}
          <Link className="a" to="/support/contact">
            contact us
          </Link>{' '}
          with any questions.
        </p>
        <UpsellTable />
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <LinkButton variant="primary" to="/settings/billing/checkout">
              Upgrade to Pro
            </LinkButton>
          }
          secondaryButton={
            <LinkButton variant="link" to="/settings/billing">
              Learn more
            </LinkButton>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
